import http from "../httpService";

const apiEndpoint = "/plan";

export function getWorkPlans(input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''
  
  return http.get(apiEndpoint + ((query) ? '/?' + query : ''))
}